// This import loads the firebase namespace along with all its type information.
import ApprovalRequest from './approval-request-model'

export async function load_approvalRequests(): Promise<ApprovalRequest[]> {
  throw 'Not implemented'
}

export async function delete_approvalRequest(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_approvalRequest(): Promise<ApprovalRequest> {
  throw 'Not implemented'
}
